import { all, call, put, takeEvery } from "@redux-saga/core/effects";
import { CombineService } from "../../util/services/combine";
import { showErrorResponse } from "../../util/varibles/global";
import { combineTreatmentActions } from "./reducer";

function* getCombineTreatmentWatcher(): Generator<any, any, any> {
    try {
        const list = yield call(CombineService.gets);
        yield put(combineTreatmentActions.getListSuccess(list))
    } catch (error) {
        showErrorResponse('Get data failed', error)
        yield put(combineTreatmentActions.getListFailure())
    }
}

export default function* combineTreatmentSaga() {
    yield all([
        takeEvery(combineTreatmentActions.getListRequest.type, getCombineTreatmentWatcher),
    ])
}
